import React, { useEffect, useState, useRef } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import {
  Button,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Typography
} from "@mui/material";
import TitleUploaded from "../../../components/TitleUploaded";
import { getData } from "../../../services/library";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import AddFact from "../alta/AddFact";
import { UrlApi } from "../../../services/apirest";
import PersonIcon from '@mui/icons-material/Person';

function FormInicioFact(props) {
  const [showForm, setShowForm] = useState(true);
  const [showAddFact, setShowAddFact] = useState(false);
  const [tiposFact, setTiposFact] = useState([]);
  const [formData, setFormData] = useState({
    id_tipofact: "",
  });
  const [clientes, setClientes] = useState([]);
  const [domicilios, setDomicilios] = useState(null);
  const [cliente, setCliente] = useState({});
  const [direccion, setDireccion] = useState({});

  const [cargando, setCargando] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const timeoutRef = useRef(null);

  useEffect(() => {
    getData("/desplegables/tipoFact", setTiposFact);
  }, []);

  // useEffect(() => {
  //   (formData.id_tipofact === 236 || formData.id_tipofact === 237) && getData("/clientes/activos", setClientes);
  // }, [formData.id_tipofact]);

  const fetchAllClientes = (texto) => {
    setCargando(true);
    fetch(`${UrlApi}/clientes/search?q=${encodeURIComponent(texto)}`)
      .then((res) => res.json())
      .then((data) => setClientes(data))
      .catch((err) => {
        console.error("Error fetch clientes:", err);
        setClientes([]);
      })
      .finally(() => setCargando(false));
  };


  useEffect(() => {
    formData.id_tipofact === 236 &&
      getData("/direccionesentrega/cli/" + formData.id_cliente, setDomicilios);
  }, [formData.id_cliente]);

  const handleNext = () => {
    setShowForm(false);
    setShowAddFact(true);
  };

  const disableNext = () => {
    if (!!formData.id_tipofact) {
      //si tengo una ampliacion en un domicilio existente:
      if (formData.id_tipofact === 236) {
        // console.log("Tengo una ampliacion en un domicilio existente.")
        if (!!formData.id_cliente && !!formData.id_domicilio) {
          return false;
        } else {
          return true;
        }
      } else if (formData.id_tipofact === 237) { //ampliacion en nuevo domicilio
        if (!!formData.id_cliente) {
          return false;
        } else {
          return true;
        }
      } else if (formData.id_tipofact === 235) {
        return false;
      }
    } else {
      return true;
    }
  }

  return (
    <Container maxWidth="xl" >
      {showForm && (
        <>
          <TitleUploaded
            title="Nueva Factibilidad"
            handleClose={() => {
              props.setShowAdd(false);
              props.setShowTable(true);
            }}
          />
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            style={{ height: "100%" }}
            pt={3}
            px={30}
          >
            <Grid
              container
              direction="column"
              border={1}
              borderColor="#ebebeb5e"
              backgroundColor="#ebebeb"
              borderRadius={2}
              p={6}
              boxShadow="0 10px 30px rgba(0,0,0,0.25), 0 4px 10px rgba(0,0,0,0.15)"
            >
              <Grid item mb={4}>
                <FormControl
                  required
                  fullWidth
                  style={{ backgroundColor: "#fff" }}
                >
                  <InputLabel>Tipo Factibilidad</InputLabel>
                  <Select
                    name="tipo"
                    label="Tipo Factibilidad"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        id_tipofact: e.target.value,
                        id_cliente:
                          e.target.value === 235 ? "" : formData.id_cliente,
                        id_domicilio: "",
                      });
                      setCliente(null);
                      setDireccion(null);
                    }}
                  >
                    {tiposFact.map((tipo) => (
                      <MenuItem key={tipo.id} value={tipo.id}>
                        {tipo.valor}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {(formData.id_tipofact === 236 ||
                formData.id_tipofact === 237) && (
                  <>
                    <Grid item mb={4}>
                      <Autocomplete
                        disableClearable
                        placeholder="Nombre, CUIT o Sisven ID"
                        options={clientes}
                        loading={cargando}
                        value={cliente}
                        inputValue={inputValue}
                        onChange={(e, value) => {
                          setFormData({
                            ...formData,
                            id_cliente: value?.id,
                            id_domicilio: "",
                          })
                          setCliente(value)
                          setDireccion(null)
                        }}
                        noOptionsText="Tipee para buscar clientes..."
                        onInputChange={(e, value, reason) => {
                          setInputValue(value);

                          if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current);
                            timeoutRef.current = null;
                          }

                          if (value?.length >= 2) {
                            timeoutRef.current = setTimeout(() => {
                              fetchAllClientes(value);
                              timeoutRef.current = null;
                            }, 300);
                          } else {
                            setClientes([]);
                          }
                        }}
                        getOptionLabel={(option) =>
                          `${option?.razon_social?.trim()} ${option?.sisven_id ? `(${option?.sisven_id})` : ""}`
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.id === value?.id
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            key={option.id}
                          >
                            <PersonIcon sx={{ fontSize: "18px", color: "#475569" }} />
                            {option?.razon_social?.trim()}{" "}
                            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              {option?.cuit && (
                                <Typography
                                  component="span"
                                  sx={{
                                    color: "#475569",
                                    fontSize: "0.85rem",
                                    fontWeight: 400,
                                  }}
                                >
                                  - CUIT: {option.cuit}
                                </Typography>
                              )}

                              {option?.sisven_id && (
                                <Typography
                                  component="span"
                                  sx={{
                                    color: "#475569",
                                    fontSize: "0.85rem",
                                    fontWeight: 400,
                                  }}
                                >
                                  Sisven: {option.sisven_id}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        )}
                        sx={{ backgroundColor: "#fff" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Cliente "
                            variant="outlined"
                            placeholder="Buscar cliente..."
                            InputProps={{
                              ...params.InputProps,
                            }}
                          />
                        )}
                      />
                    </Grid>
                    {formData.id_tipofact === 236 && (
                      <Grid item mb={4}>
                        <FormControl
                          required
                          fullWidth
                          style={{ backgroundColor: "#fff" }}
                        >
                          <InputLabel>Dirección De Entrega</InputLabel>
                          <Select
                            name="tipo"
                            label="Dirección De Entrega"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                id_domicilio: e.target.value.id,
                              });
                              setDireccion(e.target.value);
                            }}
                          >
                            {domicilios &&
                              domicilios.map((direccion, index) => (
                                <MenuItem key={index} value={direccion}>
                                  {direccion.direccion_entrega}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                  </>
                )}

              <Grid item>
                <Grid container direction="row" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleNext()}
                    disabled={disableNext()}
                  >
                    Siguiente
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      {showAddFact && (
        <AddFact
          formInicioData={formData}
          cliente={cliente} // paso los datos del cliente
          idtipofact={formData.id_tipofact}
          direccion={direccion}
          setFormData={setFormData}
          setShowForm={setShowForm}
          setShowAdd={setShowAddFact}
          setDomicilios={setDomicilios}
        />
      )}
    </Container>
  );
}

export default FormInicioFact;
